/**
 * Information about the Google product's price.
 */
export class ProductPrice {
    constructor(priceAmountMicros, priceCurrencyCode, formattedPrice, isFree, currencySymbol = null) {
        this.priceAmountMicros = priceAmountMicros;
        this.priceCurrencyCode = priceCurrencyCode;
        this.formattedPrice = formattedPrice;
        this.isFree = isFree;
        this.currencySymbol = currencySymbol;
    }
}
//# sourceMappingURL=ProductPrice.js.map